<template>
  <div class="organisation">
    <div class="options">
      <button @click="addOrganisation(organisation)"><i class="far fa-save"></i></button>
    </div>
    <input-group name="company-name" displayName="Name" placeholder="Name" v-model="organisation.meta.company.name"></input-group>
    <input-group name="company-street" displayName="Street" placeholder="Street" v-model="organisation.meta.company.street"></input-group>
    <input-group name="company-house-number" displayName="House Number" placeholder="House Number" v-model="organisation.meta.company.houseNumber"></input-group>
    <input-group name="company-postal-code" displayName="Postal Code" placeholder="Postal Code" v-model="organisation.meta.company.postalCode"></input-group>
    <input-group name="company-city" displayName="City" placeholder="City" v-model="organisation.meta.company.city"></input-group>
    <input-group name="company-country" displayName="Country" placeholder="Country" v-model="organisation.meta.company.country"></input-group>
    <input-group name="company-account" displayName="Account" placeholder="Account" v-model="organisation.meta.company.account"></input-group>
    <input-group name="company-vat" displayName="VAT" placeholder="VAT" v-model="organisation.meta.company.vat"></input-group>
    <input-group name="company-email" displayName="Email" placeholder="Email" v-model="organisation.meta.company.email"></input-group>
    <input-group name="company-phone" displayName="Phone" placeholder="Phone" v-model="organisation.meta.company.phone"></input-group>
    <input-group name="company-fax" displayName="Fax" placeholder="Fax" v-model="organisation.meta.company.fax"></input-group>
    <input-group name="company-website" displayName="Website" placeholder="Website" v-model="organisation.meta.company.website"></input-group>
    <input-group name="company-legal" displayName="Legal" placeholder="Legal" v-model="organisation.meta.company.legal"></input-group>
  </div>
</template>

<script>
import InputGroup from "@/components/inputs/InputGroup"
export default {
  name: 'OrganisationForm',
  components: {
    InputGroup,
  },
  data() {
    return {

    }
  },
  computed: {
    organisation: {
      get() {
        return { meta: {company: {}}};
      },
      set(organisation) {
        this.$emit("input", organisation);
      }
    }
  },
  methods: {
    addOrganisation(organisation) {
      this.$store.dispatch("addOrganisation", organisation);
    }
  }
}
</script>

<style scoped>

</style>